import React from 'react';

// react router dom
import { Routes, Route } from  'react-router-dom';

// pages
import Header from './layout/Header';
import Index from './pages/Index';
import About from './pages/About';
import Blog1 from './pages/Blog1';
import Blog2 from './pages/Blog2';
import BlogDetail1 from './pages/BlogDetail1';
import BlogDetail2 from './pages/BlogDetail2';
import Contact from './pages/Contact';
import FeatureDetail1 from './pages/FeatureDetail1';
import FeatureDetail2 from './pages/FeatureDetail2';
import Features1 from './pages/Features1';
import Features2 from './pages/Features2';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './layout/Footer';
import CustomScrollbar from './components/CustomScrollbar';
import Preloader from './components/Preloader';
import WaitingList from './pages/WaitingList';
import Demo from './pages/Demo';
import ContactForm from './components/DemoForm';

const Markup = () => {

    return (
        <>
            <Preloader/>
            <CustomScrollbar/>
            <div className="main-wrapper">
                {/* header - start */}
                <Header type='navigation-1' />
                {/* header - end */}
                <Routes>
                    <Route path="/" element={<Index/>} />
                    <Route path="/about" element={<About/>} />
                    <Route path="/contact" element={<Contact/>} />
                    <Route path="/feature-detail-1" element={<FeatureDetail1/>} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
                    <Route path="/waiting-list-form" element={<WaitingList/>} />
                    <Route path="/request-demo" element={<Demo/>} />

                </Routes>
                {/* footer - start */}
                <Footer/>
                {/* footer - end */}
            </div>
        </>
    );
};

export default Markup;
